<template>
  <div class="page">
    <div class="sechout">
      <div class="sech-left" @click="back()">
        <van-icon name="arrow-left" color="#181616" size="20" style="padding-left:16px" />
      </div>
      <div class="sech-title">活动列表</div>
      <div class="sech-right"></div>
    </div>
    <img @click="toActivityDetail" class="active_bg" src="../../../../assets/house/property/active_bg.png" alt="">
    <img @click="toActivityDetail" class="active_bg" src="../../../../assets/house/property/active_bg.png" alt="">
    <img @click="toActivityDetail" class="active_bg" src="../../../../assets/house/property/active_bg.png" alt="">
  </div>
</template>

<script>
  export default {
    methods: {
      back() {
        this.$router.go(-1);
      },
      toActivityDetail() {
        this.$router.push('/house/property/propertyActivityDetail')
      }
    }
  }
</script>

<style lang="less" scoped>
  .page {
    height: 100%;
    background-color: #f5f5f5;
  }

  .sechout {
    padding-top: 22px;
    margin-bottom: 16px;
    height: 44px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .sech-left,
  .sech-right {
    width: 104px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .sech-title {
    font-size: 17px;
    font-weight: 500;
    color: #222325;
  }

  .active_bg {
    width: 100%;
  }
</style>